export const errorHandling = (e: Error) => {
    if (import.meta.env.DEV) {
        console.error('Error while loading module:', e);
    }
    throw new Error("Can't load module");
};
